/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Partial_Italics_TooltipInputs */



/**
* | output |
* | --- |
* | "Check for Events where some words or lines are italicized" |
*
* @param {Style_Guide_Manager_Partial_Italics_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_partial_italics_tooltip = /** @type {((inputs?: Style_Guide_Manager_Partial_Italics_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Partial_Italics_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verifier les evenements ou certains mots ou lignes sont en italique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie, ob in bestimmten Fällen einzelne Wörter oder Zeilen kursiv gedruckt sind.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlla gli eventi in cui alcune parole o righe sono in corsivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверьте события, в которых некоторые слова или строки выделены курсивом.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprobar eventos en los que algunas palabras o líneas estén en cursiva")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检查事件中是否存在某些单词或行以斜体显示的情况。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一部の単語や行が斜体になっているイベントを確認します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उन घटनाओं की जाँच करें जहाँ कुछ शब्द या पंक्तियाँ इटैलिक में लिखी गई हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verifique os eventos em que algumas palavras ou linhas estão em itálico.")
	return /** @type {LocalizedString} */ ("Check for Events where some words or lines are italicized")
});